import type { User } from 'firebase/auth';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useState } from 'react';
import type { FirebaseClientConfig } from '@/utils/firebase_auth_client';
import { getClientAuth } from '@/utils/firebase_auth_client';
import type { AuthErrorDisplay } from '@/utils/firebase_auth_error';
import { toAuthErrorDisplay, toLocalAuthErrorDisplay } from '@/utils/firebase_auth_error';

const usePasswordAuth = (firebaseConfig: FirebaseClientConfig) => {
  const [user, setUser] = useState<User | null>(null);
  const [error, setError] = useState<AuthErrorDisplay | null>(null);
  const [email, setEmail] = useState<string | null>(null);
  const [password, setPassword] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const signIn = () => {
    if (isSubmitting) {
      return;
    }
    setError(null);

    if (!email || !password) {
      setError(
        toLocalAuthErrorDisplay('app/missing-input', 'メールアドレスとパスワードを入力してください')
      );
      return;
    }

    setIsSubmitting(true);
    signInWithEmailAndPassword(getClientAuth(firebaseConfig), email, password)
      .then((result) => {
        setUser(result.user);
      })
      .catch((err) => {
        setError(toAuthErrorDisplay(err));
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return { user, error, signIn, setEmail, setPassword, isSubmitting };
};

export default usePasswordAuth;
